<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/common/about">About</router-link>
    </div> -->
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script >
// import LocalTryPostObserver from './assets/dataConfig/local.ts';

export default {
  created() {
    window.sensors.track("JoinPageView", {});
  },
};

// eslint-disable-next-line wrap-iife
(function launchInit() {
  // 获取CDN配置文件
  const ConfigFncObservers = [];
  window.OnConfigFnc = (block) => {
    if (window.GetDataConfig) {
      try {
        block(window.GetDataConfig);
      } catch (e) {
        console.warn("some observer error");
      }
    } else ConfigFncObservers.push(block);
  };
  window.DelegateOnLoadDataConfigFnc = (getConfig) => {
    window.GetDataConfig = getConfig;
    if (ConfigFncObservers && ConfigFncObservers.length > 0) {
      ConfigFncObservers.forEach((block) => {
        try {
          block(getConfig);
        } catch (e) {
          console.warn("some observer error");
        }
      });
    }
  };
  function getDataConfig() {
    // console.log("placeholder: ", process.env.NODE_ENV === "production");
    const { ENV } = process.env.ENV_DATA;
    const IsDevEnv = ["development", "testing"].includes(ENV);
    const _host =
            "https://qmmg-cdn.masterkongchef.com/e/dicos-belray-kangchef-h5/config/";
    const _path = IsDevEnv ? "config-test.js" : "config.js";
    if (!window.GetDataConfig) {
      const ConfigPath = _host + _path;
      //   const ConfigPath =
      //     "http://10.64.146.171:5500/src/assets/dataConfig/config-test.js";
      const script = document.createElement("script");
      script.src = ConfigPath;
      document.body.appendChild(script);
    }
  }
  getDataConfig();
})();

// console.log("当前环境是：", process.env.NODE_ENV);
</script>

<style lang="scss">
  * {
    box-sizing: border-box;
  }
  html,
  body {
    width: 100%;
    max-height: 100vh;
    overflow: hidden;
  }
  body {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .main-btn {
    width: 590px;
    height: 88px;
    line-height: 88px;
    background-color: #009602;
    border-radius: 48px;

    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin: auto;

    transition: all 0.15s ease;

    a {
      color: #ffffff;
      display: block;
    }
  }

  .main-btn--disabled {
    background-color: #cccccc !important;
    border-radius: 48px;
  }

  .van-toast {
    font-size: 28px !important;
    line-height: 60px !important;
  }
</style>
